// extracted by mini-css-extract-plugin
export var paragraph = "C_bc";
export var paragraphTertiary = "C_bC";
export var paragraphWhite = "C_bB";
export var variant1 = "C_bD";
export var variant2 = "C_bF";
export var variant3 = "C_bG";